module.exports = function() {
  return new Worker(__webpack_public_path__ + "10c67feb3fe87f59e857.worker.js");
};